import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { TableCell } from '@nagel-types';
import { TABLE_CELL_RENDERERS } from './table-cell-renderers';
import { isEmptyCellValue } from './table-cell-value.utils';
import { UnsupportedCellComponent } from './renderers/unsupported-cell/unsupported-cell.component';

const defaultTableCell: TableCell = {
    type: 'plain-text',
    value: ''
};

@Component({
    selector: 'app-table-cell',
    imports: [NgComponentOutlet],
    templateUrl: './table-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellComponent {
    private readonly renderers = inject(TABLE_CELL_RENDERERS);

    cell = input<TableCell>(defaultTableCell);

    readonly displayedCell = computed(() => {
        const cell = this.cell();
        const emptyValue = cell?.options?.emptyValue;

        return emptyValue !== undefined && isEmptyCellValue(cell.value)
            ? { ...cell, value: emptyValue }
            : cell;
    });
    readonly isEmpty = computed(() => isEmptyCellValue(this.displayedCell()?.value));
    readonly renderer = computed(() => this.renderers[this.cell().type] ?? UnsupportedCellComponent);
    readonly rendererInputs = computed(() => ({ cell: this.displayedCell() }));
}
